import { drawTableOptions } from './configs';
import type { DrawChart } from './types';

export const drawChart: DrawChart = ({
  categoryList,
  data,
  element,
  month,
}) => {
  const { DataTable, LineChart } = window.google.visualization;
  const table = new DataTable();

  table.addColumn('string', '');

  for (const { title } of categoryList) {
    table.addColumn('number', title);
  }

  table.addRows(data[month]);

  new LineChart(element).draw(table, drawTableOptions);
};
